@let treeMode = mode();

<div class="tree-container {{fieldMode() ? 'field-mode' : ''}} {{readonly() ? 'readonly' : ''}} {{treeMode === 'hidden-tree' ? 'hidden-tree' : ''}}">
  @if (fieldMode()) {
  @if (label()) {
  <p class="label">{{label()}} <span class="text-error">*</span></p>
  }
  @if (locationPaths().length > 0) {
  <div class="location-paths">
    @for (item of locationPaths(); track $index) {
    <div class="flex items-center gap-1">
      <span class="location-path {{item.highlighted ? 'bg-green-700' : ''}}">
        {{ item.path }}
      </span>
    </div>
    }
  </div>
  }
  }
  <div class="h-1">
    @if (!dataSource()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
  @if(treeMode === 'location-tag') {
  <cac-control-builder [options]="statusControl"></cac-control-builder>
  }
  @if (searchable()) {
  <cac-control-builder [options]="searchControl" [class]="fieldMode() ? 'mt-4' : ''"></cac-control-builder>
  }
  @if (treeMode === 'hidden-tree' && dataSource()) {
  <cac-button (onClick)="openDialog()" class="w-fit" appearance="stroked">نمایش درختی</cac-button>
  } @else {
  <mat-tree #tree [dataSource]="filteredDataSource() ?? dataSource() ?? []" [childrenAccessor]="childrenAccessor">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <ng-container [ngTemplateOutlet]="Node" [ngTemplateOutletContext]="{
          node: node,
        }"></ng-container>
      <button mat-icon-button disabled></button>
    </mat-tree-node>
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding
      [cdkTreeNodeTypeaheadLabel]="node.label">
      <ng-container [ngTemplateOutlet]="Node" [ngTemplateOutletContext]="{
          node: node,
        }"></ng-container>
      <button mat-icon-button matTreeNodeToggle>
        <cac-icon [icon]="tree.isExpanded(node) ? 'chevron-down' : 'chevron-left'"></cac-icon>
      </button>
    </mat-tree-node>
  </mat-tree>
  }
</div>

<ng-template #Node let-node="node">
  @if (multiple()) {
  <cac-checkbox [checked]="control.value?.includes(node.id)" (onChange)="onToggleNode(node, $event)"
    class="mr-3 {{node.disabled ? 'disabled-node' : ''}} {{readonly() ? 'readonly-node' : ''}}">
    <div class="node-label">
      <ng-container [ngTemplateOutlet]="NodeLabel" [ngTemplateOutletContext]="{
          node: node,
        }"></ng-container>
    </div>
  </cac-checkbox>
  } @else {
  <div class="node-label mr-6 {{ node.id === control.value ? 'selected' : '' }}" (click)="onSelectNode(node.id)">
    <ng-container [ngTemplateOutlet]="NodeLabel" [ngTemplateOutletContext]="{
          node: node,
        }"></ng-container>
  </div>
  }
</ng-template>

<ng-template #NodeLabel let-node="node">
  <p>{{ node.label }}</p>
  <p class="text-xs text-slate-500 flex gap-1">
    @if (node.subLabel) {
    <span>{{ node.subLabel }}</span>
    }
    @if (node.status?.label) {
    <span>وضعیت: {{ node.status.label }}</span>
    }
  </p>
</ng-template>